<script>
import moment from 'moment-timezone';
import Test from "@/view/pages/tutor/human-management/test.vue";
import BusinessCoefficientCreate from "@/view/pages/business-coefficient/BusinessCoefficientCreate.vue";
import {GET_WEEKLY_SCHEDULE, GET_WEEKLY_TASK} from "@/core/services/store/tutor/tutor.module";

export default {
  name: "WeeklyTask",
  components: {BusinessCoefficientCreate, Test},
  props: {
    show: {type: Boolean, default: false},
    staff: {
      type: Object,
      default: () => ({code: "136236", name: "Nguyễn Văn A", phone: "0977886321"}),
    },
  },
  data() {
    return {
      week: null,
      events: [
        {
          dateOffset: 0,
          band: 'morning',
          start: '08:30',
          end: '12:00',
          title: '1057 – Gia sư',
          color: 'blue'
        }, {
          dateOffset: 0,
          band: 'afternoon',
          start: '13:00',
          end: '16:00',
          title: '1057 – Gia sư',
          color: 'blue'
        }, {dateOffset: 0, band: 'evening', start: '18:00', end: '21:00', title: '1057 – Gia sư', color: 'blue'}
      ],
      loading: false
    };
  },
  mounted() {
    const monday = moment().startOf('isoWeek');     // moment object
    this.week = monday.format('YYYY-MM-DD');
  },
  computed: {
    weekDays() {
      if (!this.week) return [];
      const labels = ['Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7', 'Chủ nhật'];
      const monday = moment(this.week, 'YYYY-MM-DD', true).startOf('isoWeek');

      return labels.map((label, i) => {
        const d = monday.clone().add(i, 'days');
        return {
          label,
          display: d.format('DD/MM/YYYY'),
          raw: d.toDate(),
          date: d.format('YYYY-MM-DD')
        };
      });
    }
  },
  methods: {
    close() {
      this.$bvModal.hide('weekly-task-modal')
    },
    formatWeekRange() {
      if (!this.week) return '';
      const m = moment(this.week, "YYYY-MM-DD");
      const monday = m.clone().startOf("isoWeek");
      const sunday = m.clone().endOf("isoWeek");
      return `${monday.format("DD/MM/YYYY")} - ${sunday.format("DD/MM/YYYY")}`;

    },
    drawScale(containerId, startHour, endHour, number = 20) {
      const cont = document.getElementById(containerId);
      for (let h = startHour; h <= endHour; h++) {
        const t = document.createElement('div');
        t.className = 'tick';
        const minutesFromBandStart = (h - startHour) * 60;
        t.style.top = `calc(${minutesFromBandStart} * var(--ppm) + ${number}px)`;
        const label = h < 10 ? `0${h}:00` : `${h}:00`;
        t.textContent = label;
        cont.appendChild(t);
      }
    },
    toMin(t) {
      const [h, m] = t.split(':').map(Number);
      return h * 60 + m;
    },
    render() {
      this.events.forEach(ev => {
        const dayEl = document.querySelectorAll('.day')[ev.dateOffset];
        if (!dayEl) return;
        const bandEl = dayEl.querySelector(`.band[data-name="${ev.band}"]`);
        if (!bandEl) return;

        const el = document.createElement('div');
        el.className = `event ${ev.color}`;
        const startMinAbs = this.toMin(ev.start);
        const endMinAbs = this.toMin(ev.end);

        // quy về phút trong dải
        let offsetStart = 0, bandStart = 0;
        if (ev.band === 'morning') {
          bandStart = 8 * 60;
        }
        if (ev.band === 'afternoon') {
          bandStart = 13 * 60;
        }
        if (ev.band === 'evening') {
          bandStart = 18 * 60;
        }
        offsetStart = Math.max(0, startMinAbs - bandStart);
        const offsetEnd = Math.max(offsetStart + 10, endMinAbs - bandStart); // tối thiểu 10'

        el.style.setProperty('--startMin', offsetStart);
        el.style.setProperty('--endMin', offsetEnd);
        el.textContent = ev.title;
        el.dataset.time = `${ev.start} – ${ev.end}`;
        bandEl.appendChild(el);
      });
    },
    async getDataWeeklyTask() {
      try {
        this.loading = true
        let data = await this.$store.dispatch(GET_WEEKLY_TASK, {
          credentials: {
            start_date: this.weekDays[0]?.date,
            end_date: this.weekDays[6]?.date
          },
          id: this.staff?.id
        })
        const result = data?.data?.weekly_data
        this.events = result.flatMap((item) => {
          return item.tasks.map((task) => {
            return {
              dateOffset: this.getDayNumber(item?.day_of_week),
              band: this.getTimeOfDay(task.start_date),
              start: this.getHourMinute(task.start_date),
              end: this.getHourMinute(task.end_date),
              title: `${task?.id} - ${task?.task_type_label}`,
              color: task.task_type === 4 ? 'blue' : 'pink'
            }
          })
        })
        result.forEach((date)=>{
          [{band:'morning', start:'08:00', end: '12:00'},{band:'afternoon', start:'13:00', end: '17:00'},{band:'evening', start:'18:00', end: '22:00'}].forEach((item)=>{
            const isNotWorking =  date.schedules.filter(schedule => schedule.shift_code === item.band).length === 0
            if(isNotWorking){
              this.events.push({dateOffset: this.getDayNumber(date?.day_of_week), band: item.band, start: item.start, end: item.end, title: 'Không đi làm', color: 'gray' })
            }
          })
        })
        setTimeout(() => {
          this.drawScale('scale-morning', 8, 12)
          this.drawScale('scale-afternoon', 13, 17, 10)
          this.drawScale('scale-evening', 18, 22, 25)
          this.render()
        })
      }catch (e) {

      }finally {
        this.loading = false
      }
    },
    getDayNumber(dayText) {
      switch (dayText.toLowerCase()) {
        case "thứ hai":
          return 0;
        case "thứ ba":
          return 1;
        case "thứ tư":
          return 2;
        case "thứ năm":
          return 3;
        case "thứ sáu":
          return 4;
        case "thứ bảy":
          return 5;
        case "chủ nhật":
          return 6;
        default:
          return null; // hoặc -1 nếu muốn đánh dấu lỗi
      }
    },
    getTimeOfDay(startDate) {
      const time = moment(startDate, "YYYY-MM-DD HH:mm:ss");

      if (time.isSameOrBefore(moment(startDate, "YYYY-MM-DD").hour(12).minute(0))) {
        return "morning";
      }

      if (time.isSameOrBefore(moment(startDate, "YYYY-MM-DD").hour(17).minute(30))) {
        return "afternoon";
      }

      return "evening";
    },
    getHourMinute(startDate) {
      return moment(startDate, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
    }
  }
}
</script>

<template>
  <b-modal
      id="weekly-task-modal"
      :title="'Tác vụ tuần'"
      size="xl"
      hide-footer
      body-class="p-0"
      @show="getDataWeeklyTask()"
  >
    <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height:200px;">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-else class="p-4">
      <!-- Header form -->
      <div class="row">
        <div class="col-md-6">
          <label class="mb-1">Nhân sự Admin</label>
          <input
              class="form-control"
              :value="`${staff?.userId?+staff?.userId :''} - ${staff?.name} - ${staff?.phone}`"
              readonly
          />
        </div>
        <div class="col-md-6">
          <label class="mb-1">Tuần làm việc</label>
          <el-date-picker
              v-model="week"
              type="week"
              placeholder="Chọn tuần"
              :format="formatWeekRange()"
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
              class="w-100"
              @input="getDataWeeklyTask"
          />
        </div>
      </div>

      <!-- Bảng lịch -->
      <div class="mt-4">
        <div class="d-flex align-items-center mb-2">
          <strong class="mr-2">Lịch đi làm</strong>
        </div>
        <div class="calendar">
          <div class="header1">
            <div class="hdr-left">Thời gian</div>
            <div v-for="(day,index) in weekDays" class="day-hdr" :id="`d${index}`">
              <div style="text-align: center">
                {{ day.label }}
                <small style="display: block">{{ day.display }}</small>
              </div>
            </div>
          </div>
          <div class="body">
            <div class="time" style="">
              <div class="shift" style="height:328px">
                Sáng
              </div>
              <div class="timeline" id="scale-morning" style="height:328px">
              </div>
              <div class="shift" style="height:328px">
                Chiều
              </div>
              <div class="timeline" id="scale-afternoon" style="height:328px">
              </div>
              <div class="shift" style="height:328px">
                Tối
              </div>
              <div class="timeline" id="scale-evening" style="height:328px">
              </div>
            </div>
            <div class="day" data-date="">
              <div style="height: 20px"></div>
              <div class="band" data-name="morning"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="afternoon"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="evening"></div>
            </div>
            <div class="day" data-date="">
              <div style="height: 20px"></div>
              <div class="band" data-name="morning"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="afternoon"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="evening"></div>
            </div>
            <div class="day" data-date="">
              <div style="height: 20px"></div>
              <div class="band" data-name="morning"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="afternoon"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="evening"></div>

            </div>
            <div class="day" data-date="">
              <div style="height: 20px"></div>
              <div class="band" data-name="morning"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="afternoon"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="evening"></div>

            </div>
            <div class="day" data-date="">
              <div style="height: 20px"></div>
              <div class="band" data-name="morning"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="afternoon"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="evening"></div>
            </div>
            <div class="day" data-date="">
              <div style="height: 20px"></div>
              <div class="band" data-name="morning"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="afternoon"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="evening"></div>
            </div>
            <div class="day" data-date="">
              <div style="height: 20px"></div>
              <div class="band" data-name="morning"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="afternoon"></div>
              <div style="height: 20px"></div>
              <div style="height: 20px"></div>
              <div class="band" data-name="evening"></div>
            </div>
          </div>
        </div>

        <div class="legend">
          <span class="dot blue"></span>Gia sư
          <span class="dot pink" style="margin-left:12px;"></span> Tác vụ khác
          <span class="dot gray" style="margin-left:12px;"></span> Không đi làm
        </div>
        <!-- Footer buttons -->
        <div class="d-flex justify-content-end p-3">
          <button class="btn btn-secondary mr-3" @click="close">Đóng</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
@import "./WeeklyTask.css";

.schedule-table .table thead th {
  background: #f7f7f7;
  vertical-align: middle;
}

.align-middle {
  vertical-align: middle !important;
}

.thead-light th {
  border-top: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
}
</style>
